import { useEffect } from 'react';

export const useDelayFocus = (ref: React.RefObject<HTMLElement>, condition: boolean, delay: number = 1000): void => {
  useEffect(() => {
    if (condition) {
      const timer = setTimeout(() => {
        ref?.current?.focus();
      }, delay);

      return () => clearTimeout(timer);
    }
  }, [condition, delay]);
};
